import { React, useEffect, useState } from "react";
import "../../../styles/desktop/alarmes.css";
import "../../../styles/desktop/CampoLuzes.css";

const Alarmes = ({ alarmes }) => {
    const [alarmeState, setAlarmeStates] = useState({
    });

    useEffect(() => {
        const updateState = () => {
            setAlarmeStates((prevState) => {
                const updatedState = { ...prevState };

                // Atualizar cada alarme no estado com base nos dados do servidor
                Object.keys(updatedState).forEach((alarmeKey) => {
                    const alarmeConfig = updatedState[alarmeKey];
                    const alarmeServidor = alarmes.find((alarme) => alarme.nome === alarmeConfig.nome);

                    if (alarmeServidor) {
                        updatedState[alarmeKey] = {
                            ...alarmeConfig,
                            status: alarmeServidor.status, // Atualiza o status correto
                        };
                    }
                });

                return updatedState; // Retorna o estado atualizado
            });
        };

        updateState();
    }, [alarmes]);

    return (
        <div className="GrupoAlarmes">
            <div className="campoBomba">
                <div className="campoBombaAlarme">
                    <div id="alarme1" className="alarme">
                        <p className="titleAlarme">Bomba 01 cisterna sub.</p>
                        <div className={alarmeState.alarme1 ? "alertCircle" : "circleAlarm"} id="circleAlarme1">
                            <p>{alarmeState.alarme1 ? "Defeito" : "Ligada"}</p>
                        </div>
                    </div>
                    <div id="alarme2" className="alarme">    
                        <p className="titleAlarme">Bomba 02 cisterna sub.</p>
                        <div className={alarmeState.alarme2 ? "alertCircle" : "circleAlarm"} id="circleAlarme2">
                            <p>{alarmeState.alarme2 ? "Defeito" : "Ligada"}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="campoBomba">
                <div className="campoBombaAlarme">
                    <div id="alarme4" className="alarme">
                    <p className="titleAlarme">Bomba de incêndio</p>
                        <div className={alarmeState.alarme4 ? "alertCircle" : "circleAlarm"} id="circleAlarme4">
                            <p>{alarmeState.alarme4 ? "Defeito" : "Ligada"}</p>
                        </div>
                    </div>
                    <div id="alarme5" className="alarme">
                        <p className="titleAlarme">VPR</p>
                        <div className={alarmeState.alarme5 ? "alertCircle" : "circleAlarm"} id="circleAlarme5">
                            <p>{alarmeState.alarme5 ? "Defeito" : "Ligada"}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Alarmes;